import { useEffect } from "react";
import { Select } from "src/elements";

import { useApi } from "src/api";
import { useMerchants } from "./store/atoms";
import { useLoaders } from "../InlineLoader";
import { RouteGetAuthSsoMerchants } from "@CommonApi/auth/sso/merchants";
import { getLoginToken, setLoginToken } from "src/utils";
import { decodeJwtPayload } from "src/utils/jwt";
import { useToasts } from "../Toasts";
import { RoutePostAuthSsoSwitchMerchant } from "@CommonApi/auth/sso/switchMerchant";
import { isApiError } from "@CommonApi/apiError";
import { User } from "@CommonApi/auth/login";

export const MerchantSwitcher = () => {
  const { getSsoAuthMerchantsApi, postSsoAuthSwitchMerchantApi } = useApi();
  const { merchants, setMerchants } = useMerchants();
  const { hasLoader } = useLoaders();
  const { toast } = useToasts();
  let currentMerchantId: number;
  try {
    currentMerchantId = (decodeJwtPayload(getLoginToken()!) as { user: User }).user.merchantId;
  } catch (error) {
    toast({
      title: "Failed to initialize MerchantSwitcher component",
      error,
    });
    return;
  }

  const options = (merchants || []).map((merchant) => ({
    value: merchant.id,
    label: merchant.name,
  }));

  useEffect(() => {
    (async () => {
      const response = await getSsoAuthMerchantsApi();
      if (!response) {
        return;
      }
      setMerchants(response.merchants);
    })();
  }, []);

  const switchToMerchant = async (merchantId: number) => {
    if (merchantId === currentMerchantId) {
      return;
    }
    const resp = await postSsoAuthSwitchMerchantApi(merchantId);
    if (resp) {
      if (isApiError(resp)) {
        toast({
          title: "Failed to switch active merchant",
          message: resp.errorMessage,
          type: "ERROR",
        });
      } else {
        setLoginToken(resp.token);
        window.location.reload();
      }
    } else {
      toast({
        title: "Failed to switch active merchant",
        message: "No response data from backend",
        type: "ERROR",
      });
    }
  };

  return (
    <Select
      title="Retailer"
      placeholder=""
      options={options}
      value={currentMerchantId}
      setValue={(merchantId: number) => {
        switchToMerchant(merchantId);
      }}
      isLoading={hasLoader(RouteGetAuthSsoMerchants) || hasLoader(RoutePostAuthSsoSwitchMerchant)}
    />
  );
};
